export default __webpack_public_path__ + "static/media/cats.812c5055.png";